export enum AsyncValueStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  COMPLETE = 'complete',
  ERROR = 'error',
}

export type AsyncValue<T> = {
  status: AsyncValueStatus;
  error?: unknown;
  value?: T;
};
